// Model.js
// -----------------------
// @module Case
define("C25.Blog.Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/BlogList/SuiteScript2/Blog.Service.ss"
            ),
            true
        )
});
});
